
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h24v24H0z","data-name":"사각형 1188","fill":"none"}}),_c('path',{attrs:{"d":"M18.9 4l-5.3 8.2-.3.5v6.6L10.7 18v-6l-.4-.5L5.2 4h13.7m3.7-2H1.4l7.3 10.6v6.6l6.6 3.3v-9.3L22.6 2z"}})])
          )
        }
      }
    